/**
 * Created by Carsten Bühler
 * User: CBuehler on 17.02.2016
 * Copyright: xdot GmbH 2015
 */

'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';

import { translation } from 'plugin/liferay-widgets-react-web';
import { UserHistoryEntry } from 'plugin/user-state-history-portlet';
import { Badge, OverlayTrigger, Tooltip } from 'external/react-bootstrap';

const StateValueLabel = ({ item, showText = true, stateName = undefined }) => {
    let tooltip;
    if (!item) {
        return null;
    }

    const getTranslation = (activeState) => {
        let title = translation.trans((activeState.className ? (activeState.className + '.') : '') + activeState.propName);

        if (activeState.className === 'ManualBooleanState') {
            title = 'Ereigniszustand';
        }
        return title;
    };

    if (item.userMeta && item.timestamp) {
        tooltip = (
            <Tooltip placement="bottom" className="in" id="tooltip-bottom">
                {stateName ? stateName : (getTranslation(item)) + ': ' + item.state.stateTitle}<br/>
                <UserHistoryEntry userMeta={item.userMeta} timestamp={item.timestamp}/>
                {item.comment && <div> Kommentar: {item.comment} </div>}
            </Tooltip>
        );
    }

    let content = (
        <Badge className={item.state && item.state.style && ' ' + item.state.style + ' '}>
            <span>
            {showText && item.state && item.state.stateTitle || ''}
            </span>
        </Badge>
    );

    if (tooltip) {
        content = (
            <OverlayTrigger trigger={[ 'click', 'hover' ]} placement="bottom" overlay={tooltip}>
                {content}
            </OverlayTrigger>
        );
    }
    return (
        <React.Fragment>
            {content}
        </React.Fragment>
    );
};

StateValueLabel.propTypes = {
    item: PropTypes.object.isRequired,
    showText: PropTypes.bool,
    stateName: PropTypes.string,
};

export default StateValueLabel;



// WEBPACK FOOTER //
// ./js/components/StateValueLabel.jsx